<template>
  <div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="col-md-12 col-sm-12 col-xs-12 h-100 d-flex">
        <div class="col-md-3 col-sm-4 col-xs-12">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h5>KHÁCH HÀNG</h5>
          </div>
          <input type="hidden" class="form-control" v-model="customer.id"/>
          <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorCustomerPhone ? 'has-error' : ''">
            <label>Số điện thoại<span class="error-symbol"></span></label>
            <input type="text" class="form-control" v-model="customer.phone" @focusout="autoFillCustomer"
                   placeholder="Nhập số điện thoại..."/>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorCustomerName ? 'has-error' : ''">
            <label>Tên khách hàng<span class="error-symbol"></span></label>
            <input type="text" class="form-control" v-model="order.customer_name"
                   placeholder="Nhập tên khách hàng ..."/>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorCustomerAddress ? 'has-error' : ''">
            <label>Địa chỉ<span class="error-symbol"></span></label>
            <input type="text" class="form-control" v-model="order.customer_address"
                   placeholder="Nhập địa chỉ..."/>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorCustomerEmail ? 'has-error' : ''">
            <label>Email</label>
            <input type="text" class="form-control" v-model="order.customer_email"
                   placeholder="Nhập email..."/>
          </div>

          <div class="form-group col-md-12 col-sm-12 col-xs-12 d-flex flex-column">
            <label>Lịch sử chăm sóc</label>
            <textarea class="form-control" v-model="order.care_notes" style="height: 68px!important;"></textarea>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h5>ĐƠN HÀNG</h5>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <label>Ngày tạo</label>
            <date-picker v-model="order.created_date" valueType="format"></date-picker>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <label>Nhân viên chăm sóc</label>
            <multiselect v-model="order.pic" id="ajax" label="name" track-by="code"
                         placeholder="Nhập để tìm kiếm nhân viên"
                         open-direction="bottom" :options="users" :multiple="false" :searchable="true"
                         :loading="loadingUser" :internal-search="false" :clear-on-select="false"
                         :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                         :allow-empty="false" :disabled="disablePic"
                         :show-no-results="false" :hide-selected="false" @search-change="debounceUser">
            </multiselect>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <label>Mã vận chuyển</label>
            <input type="text" class="form-control" v-model.number="order.shipping_code"
                   placeholder="Nhập mã vận chuyển..."/>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorDebt ? 'has-error' : ''">
            <label>Phí vận chuyển (VNĐ)</label>
            <currency-input v-model.number="order.shipping_fee"
                   placeholder="Nhập phí vận chuyển ..."/>
          </div>

          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <label>Trạng thái đơn hàng</label>
            <div class="d-flex">
              <multiselect v-model="order.data_status" :options="statusList" :multiple="false" :close-on-select="true"
                           :limit="1"
                           @select="onSelectStatus($event, order.data_status)"
                           @remove="onRemoveStatus($event, order.data_status)"
                           placeholder="Vui lòng chọn" label="text" track-by="code"></multiselect>
              <multiselect v-model="order.data_sub_status" :limit="1" :options="statusDetailList" :multiple="false"
                           :close-on-select="true" placeholder="Vui lòng chọn" label="text"
                           track-by="code"></multiselect>
            </div>
          </div>
          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <label>Nguồn đơn</label>
            <div class="d-flex">
              <multiselect v-model="order.data_source" :options="data_source" :multiple="false" :close-on-select="true"
                           :limit="1"
                           @select="onSelectSource($event, order.data_source)"
                           @remove="onRemoveSource($event, order.data_source)"
                           placeholder="Vui lòng chọn" label="text" track-by="code"></multiselect>
              <multiselect v-model="order.data_channel" :options="data_channel" :multiple="false"
                           :close-on-select="true" :limit="1"
                           placeholder="Vui lòng chọn" label="text" track-by="code"></multiselect>
            </div>
          </div>
        </div>
        <div ref="paymentRef" class="col-md-5 col-sm-4 col-xs-12 border-left flex-column d-flex justify-content-between">
          <div>
            <div class="col-md-12 col-sm-12 col-xs-12">
              <h5>THANH TOÁN</h5>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
              <b-tabs content-class="mt-3">
                <b-tab title="Tổng đơn hàng" active>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Số tiền cần thanh toán (VNĐ)</label>
                    <h4>{{getTotalAmount | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Số tiền đã thanh toán (VNĐ)</label>
                    <h4>{{getTotalPaidAmount | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Nợ (VNĐ)</label>
                    <h4>{{getTotalDebt | format_currency}}</h4>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="pull-left">
                      <span @click="showHistoryPayment" style="cursor:pointer; color: #007bff" :hidden="id === null">
                        Lịch sử thanh toán
                      </span>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Thanh toán 1 lần">
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Số tiền cần thanh toán (VNĐ)</label>
                    <h4>{{getAmount | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Số tiền đã thanh toán (VNĐ)</label>
                    <h4>{{getPaidAmount | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Nợ (VNĐ)</label>
                    <h4>{{getDebt | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <b-button variant="success" @click="$bvModal.show('oneTimePaymentModal')" :disabled="id === null || !isEditable || disabledSave">
                      <i class="fa fa-money" aria-hidden="true"></i> Thanh toán</b-button>
                  </div>

                </b-tab>
                <b-tab title="Thanh toán định kỳ">
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Số tiền cần thanh toán (VNĐ)</label>
                    <h4>{{getAnnualAmount | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Số tiền đã thanh toán (VNĐ)</label>
                    <h4>{{getAnnualPaidAmount | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <label>Nợ (VNĐ)</label>
                    <h4>{{getAnnualDebt | format_currency}}</h4>
                  </div>
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <b-button variant="success" @click="$bvModal.show('annualPaymentModal')" :disabled="id === null || !isEditable || disabledSave">
                      <i class="fa fa-money" aria-hidden="true"></i> Thanh toán</b-button>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-left">
          <b-button variant="danger" @click="save" :disabled="!isEditable || disabledSave || saving">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Lưu đơn hàng</b-button>
          <b-button variant="warning" @click="showOrderHistory">Lịch sử đơn hàng</b-button>
          <b-button variant="success" @click="showCallHistory">Lịch sử gọi điện</b-button>
          <b-button variant="secondary" @click="back"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Đóng</b-button>
        </div>
      </div>
    </div>

    <b-modal size='lg' id="orderHistoryModal" hide-footer title="Lịch sử đơn hàng">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <DataHistory :orderId="id"></DataHistory>
      </div>
    </b-modal>
    <b-modal size='lg' id="callHistoryModal" hide-footer title="Lịch sử gọi điện">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <OrderCallHistory :orderId="id"></OrderCallHistory>
      </div>
    </b-modal>
    <b-modal size='lg' id="historyPaymentModal" hide-footer title="Lịch sử thanh toán">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <OrderPaymentHistory :orderId="id" :onPaymentChanged="onPaymentChanged"></OrderPaymentHistory>
      </div>
    </b-modal>
    <b-modal size='sm' id="oneTimePaymentModal" hide-footer title="Thanh toán"
             header-class="crm-modal">
      <OneTimePayment :orderId="id" :order="order"/>
    </b-modal>
    <b-modal size='sm' id="annualPaymentModal" hide-footer title="Thanh toán"
             header-class="crm-modal">
      <OneTimePayment :orderId="id" :order="order" type="ANNUAL_BUY"/>
    </b-modal>
    <b-button v-if="fetch_data" class="open-btn" variant="primary" @click="toggle"><i class="fa fa-comments" aria-hidden="true"></i></b-button>
    <div v-if="fetch_data" class="slidein" :class="openComment ? 'open' : ''" :style="{'width': paymentWidth + 'px'}">
      <div class="message-header">Tin nhắn <b>{{order.customer.name ? order.customer.name : order.customer.phone}}</b></div>
      <ChatBox :orderId="id"/>
      <button class="close-btn" @click="toggle">x</button>
    </div>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import {debounce, isNumber} from 'lodash'
import UserApi from '../../api/user'
import CustomerApi from '../../api/customer'
import Utils from '../../common/utils'
import ProductAPI from '../../api/product'
import DataStatusAPI from '../../api/dataStatus'
import DataSubStatusAPI from '../../api/dataSubStatus'
import DataSourceAPI from '../../api/dataSource'
import DataChannelAPI from '../../api/dataChannel'
import {mapGetters} from 'vuex'
import OrderApi from '../../api/orderApi'
import ProductTable from '../../components/ProductTable'
import DataHistory from './DataHistory'
import OrderCallHistory from './OrderCallHistory'
import OrderPaymentHistory from './OrderPaymentHistory'
import {eventBus} from '../../main'
import OneTimePayment from './OneTimePayment'
import {PERMISSION_KEY, MAX_SALE_USER_NUMBER} from '../../common/constant'
import * as Constants from '../../common/constant'
import ChatBox from './ChatBox'

export default {
  name: 'OrderAdd',
  components: {
    'va-box': VABox,
    DatePicker,
    Multiselect,
    ProductTable,
    DataHistory,
    OrderCallHistory,
    OrderPaymentHistory,
    OneTimePayment,
    ChatBox
  },
  props: {
    disablePic: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: Number,
      default: null
    },
    hideModal: {
      type: Function
    },
    disabledSave: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      id: null,
      isEdit: false,
      company: null,
      order: {
        created_date: moment().format('yyyy-MM-DD'),
        product: null,
        price: 0,
        debt: 0,
        pic: null,
        due_date: null,
        annual_debt: 0,
        annual_due_date: null,
        customer: null,
        shipping_code: null,
        shipping_fee: 0,
        data_status: null,
        data_sub_status: null,
        data_source: null,
        data_channel: null,
        debt_status: null,
        amount: 0,
        annual_amount: 0,
        discount_value: 0,
        discount_type: '',
        care_notes: '',
        customer_name: '',
        customer_address: '',
        customer_email: ''
      },
      products: [],
      loadingProduct: false,
      debounceProduct: null,
      users: [],
      loadingUser: false,
      debounceUser: null,
      customers: [],
      loadingCustomer: false,
      debounceCustomer: null,
      statusList: [],
      statusDetailList: [],
      data_source: [],
      data_channel: [],
      debt_status_list: Constants.DEBT_STATUS_LIST,
      click: false,
      saving: false,
      loading: false,
      customer: {
        id: null,
        name: null,
        phone: null,
        address: null,
        email: null,
        company_id: null,
      },
      clickCustomer: false,
      savingCustomer: false,
      productLoading: false,
      productFields: [
        {
          key: 'id',
          label: 'ID'
        }, {
          key: 'product_name',
          label: 'Tên sản phẩm'
        }, {
          key: 'price',
          label: 'Giá tiền'
        }, {
          key: 'wholesale_price',
          label: 'Giá buôn'
        }, {
          key: 'discount',
          label: 'Giảm giá'
        }, {
          key: 'sale_price',
          label: 'Giá bán'
        }, {
          key: 'quantity',
          label: 'Số lượng'
        }, {
          key: 'total',
          label: 'Thành tiền'
        }, {
          key: 'actions',
          label: 'Tuỳ chọn'
        }
      ],
      productItems: [],
      annualPayment: {
        value: 0,
        paid_payment_amount: 0,
        debt: 0
      },
      oneTimePayment: {
        value: 0,
        paid_payment_amount: 0,
        debt: 0
      },
      showPaymentBtn: false,
      isEditable: true,
      selectedCrawlId: null,
      openComment: false,
      fetch_data: false,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorPrice () {
      return !isNumber(this.order.price)
    },
    errorDebt () {
      return !isNumber(this.order.debt)
    },
    errorAnnualDebt () {
      return !isNumber(this.order.annual_debt)
    },
    errorCustomerName () {
      return this.isEmptyCustomerForm(this.customer.name)
    },
    errorCustomerPhone () {
      return this.isEmptyCustomerForm(this.customer.phone)
    },
    errorCustomerAddress () {
      return this.isEmptyCustomerForm(this.customer.address)
    },
    errorCustomerEmail () {
      return false
    },
    errorOneTimePayment () {
      return !isNumber(this.oneTimePayment.value) || this.oneTimePayment.value === 0
    },
    errorAnnualPayment () {
      return !isNumber(this.annualPayment.value) || this.annualPayment.value === 0
    },
    getTotalAmount () {
      return this.order.amount + this.order.annual_amount
    },
    getTotalPaidAmount () {
      return this.order.change_amount + this.order.annual_change_amount
    },
    getTotalDebt () {
      return this.order.amount - this.order.change_amount + this.order.annual_amount - this.order.annual_change_amount
    },
    getAmount () {
      return this.order.amount
    },
    getPaidAmount () {
      return this.order.change_amount
    },
    getDebt () {
      return this.order.amount - this.order.change_amount
    },
    getAnnualAmount () {
      return this.order.annual_amount
    },
    getAnnualPaidAmount () {
      return this.order.annual_change_amount
    },
    getAnnualDebt () {
      return this.order.annual_amount - this.order.annual_change_amount
    },
    paymentWidth () {
      return this.$refs.paymentRef.clientWidth + 40
    }
  },
  async mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    if (!Utils.isAdminUser(this.userInfo) && !Utils.isSuperUser(this.userInfo)) {
      this.order.pic = {code: this.userInfo.id, name: this.userInfo.username}
    }

    if (this.orderId) {
      this.id = this.orderId
    }

    await this.initDataStatus()
    this.filterUser('')
    this.filterProduct('')
    this.filterCustomer('')
    await this.getOrderDetail()

    this.isEditable = this.hasEditPermission()
  },
  created () {
    this.debounceProduct = debounce(this.filterProduct.bind(this), 500)
    this.debounceUser = debounce(this.filterUser.bind(this), 500)
    this.debounceCustomer = debounce(this.filterCustomer.bind(this), 500)
    eventBus.$on('orderDetailChanged', (id) => {
      this.getOrderDetail()
    })
  },
  methods: {
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE)
    },
    async getOrderDetail () {
      this.loading = true
      if (this.id) {
        try {
          this.isEdit = true
          const orderDetail = (await OrderApi.get(this.id)).data.data
          this.order = {...orderDetail}
          this.customer.id = this.order.customer.id
          this.customer.name = this.order.customer.name
          this.customer.phone = this.order.customer.phone
          this.customer.address = this.order.customer.address
          this.customer.email = this.order.customer.email
          if (this.order.data_status) {
            this.order.data_status = {code: this.order.data_status.id, text: this.order.data_status.name}
            let statusDetailList = this.statusList.find(item => item.code === this.order.data_status.code)
            if (statusDetailList) {
              this.statusDetailList = statusDetailList.details
            }
          }
          if (this.order.data_sub_status) {
            this.order.data_sub_status = {code: this.order.data_sub_status.id, text: this.order.data_sub_status.name}
          }
          if (this.order.data_source) {
            this.order.data_source = {code: this.order.data_source.id, text: this.order.data_source.name}
            let data_channel = this.data_source.find(item => item.code === this.order.data_source.code)
            if (data_channel) {
              this.data_channel = data_channel.details
            }
          }
          if (this.order.data_channel) {
            this.order.data_channel = {code: this.order.data_channel.id, text: this.order.data_channel.name}
          }
          if (this.order.debt_status) {
            let debt_status_text = this.debt_status_list.find(item => item === this.order.debt_status)
            this.order.debt_status = {code: this.order.debt_status, text: debt_status_text ? debt_status_text.text : ''}
          }
          if (this.order.pic) {
            this.order.pic = {code: this.order.pic, name: this.order.pic_name}
          }
          this.selectedCrawlId = orderDetail.crawl_data
          this.loading = false
          if (this.selectedCrawlId) {
            this.fetch_data = true
          }
        } catch (err) {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        }
      }
    },
    onPaymentChanged () {
      this.getOrderDetail()
      this.notifyOrderCreated()
    },
    isEmptyCustomerForm (value) {
      return (this.clickCustomer && (value == null || value.length <= 0))
    },
    async initDataStatus () {
      Promise.all([this.getDataStatus(), this.getDataSubStatus(), this.getDataSource(), this.getDataChannel()]).then(([dataStatus, dataSubStatus, dataSource, dataChannel]) => {
        this.statusList = dataStatus.map(item => {
          const subStatus = dataSubStatus.filter(subItem => subItem.data_status === item.id).map(subItem => {
            return {code: subItem.id, text: subItem.name, data_status: subItem.data_status}
          })
          return {code: item.id, text: item.name, details: subStatus}
        })

        if (!this.id) {
          this.order.data_status = this.statusList.find(item => item.text === 'Chưa xác nhận')
          if (this.order.data_status) {
            this.statusDetailList = this.order.data_status.details
            this.order.data_sub_status = this.order.data_status.details.find(item => item.text === 'Chưa xử lý')
          }
        }

        this.data_source = dataSource.map(item => {
          const subList = dataChannel.filter(subItem => subItem.data_source === item.id).map(subItem => {
            return {code: subItem.id, text: subItem.name, data_source: subItem.data_source}
          })
          return {code: item.id, text: item.name, details: subList}
        })
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    async getDataStatus () {
      const response = await DataStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSubStatus () {
      const response = await DataSubStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSource () {
      const response = await DataSourceAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    async getDataChannel () {
      const response = await DataChannelAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    back () {
      this.hideModal('orderDetailModal')
    },
    validate () {
      return !this.errorAnnualDebt && !this.errorDebt && !this.errorPrice
    },
    buildDto () {
      const orderDto = {
        id: this.order.id,
        company_id: this.company.id,
        created_date: this.order.created_date,
        product_id: null,
        price: this.order.price,
        debt: this.order.debt,
        due_date: this.order.due_date,
        annual_debt: this.order.annual_debt,
        annual_due_date: this.order.annual_due_date,
        pic_id: this.order.pic !== null ? this.order.pic.code : null,
        customer_id: null,
        shipping_code: this.order.shipping_code,
        shipping_fee: this.order.shipping_fee,
        data_status_id: null,
        data_sub_status_id: null,
        data_source_id: null,
        data_channel_id: null,
        debt_status: null,
        care_notes: this.order.care_notes,
        customer_name: this.order.customer_name,
        customer_address: this.order.customer_address,
        customer_email: this.order.customer_email
      }
      if (this.order.product) {
        orderDto.product_id = this.order.product.code || this.order.product.id
      }
      if (this.order.pic) {
        orderDto.pic_id = this.order.pic.code || this.order.pic.id
      }
      if (this.order.customer) {
        orderDto.customer_id = this.order.customer.id
      }
      if (this.order.data_status) {
        orderDto.data_status_id = this.order.data_status.code || this.order.data_status.id
      }
      if (this.order.data_sub_status) {
        orderDto.data_sub_status_id = this.order.data_sub_status.code || this.order.data_sub_status.id
      }
      if (this.order.data_source) {
        orderDto.data_source_id = this.order.data_source.code || this.order.data_source.id
      }
      if (this.order.data_channel) {
        orderDto.data_channel_id = this.order.data_channel.code || this.order.data_channel.id
      }
      if (this.order.debt_status) {
        orderDto.debt_status = this.order.debt_status.code || this.order.debt_status.id
      }
      return orderDto
    },
    save () {
      this.click = true
      this.saving = true
      this.loading = true
      if (!this.validate()) {
        this.saving = false
        this.loading = false
        return
      }
      if (this.customer.id === null) {
        this.clickCustomer = true
        this.savingCustomer = true
        this.customer.name = this.order.customer_name
        this.customer.address = this.order.customer_address
        this.customer.email = this.order.customer_email
        this.customer.company_id = this.company.id
        CustomerApi.create(this.customer).then(cres => {
          this.savingCustomer = false
          if (cres != null && cres.data != null) {
            this.customer.id = cres.data.data.id
          }
          this.createOrUpdateOrder()
        })
      } else {
        if (this.customer.name !== this.order.customer_name || this.customer.address !== this.order.customer_address || this.customer.email !== this.order.customer_email) {
          this.customer.name = this.order.customer_name
          this.customer.address = this.order.customer_address
          this.customer.email = this.order.customer_email
          this.customer.company_id = this.company.id
          CustomerApi.update(this.customer).then(cres => {
            this.savingCustomer = false
            if (cres != null && cres.data != null) {
              this.customer.id = cres.data.data.id
            }
            this.createOrUpdateOrder()
          })
        } else {
          this.createOrUpdateOrder()
        }
      }
    },
    notifyOrderCreated (id) {
      eventBus.$emit('orderCreated', id)
    },
    createOrUpdateOrder () {
      const dto = this.buildDto()
      dto.customer_id = this.customer.id
      if (dto.id) {
        OrderApi.update(dto).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
            this.id = res.data.id
            this.getOrderDetail()
          }
          // this.back()
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        OrderApi.create(dto).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
            this.notifyOrderCreated(res.data.data.id)
            this.id = res.data.data.id
            this.getOrderDetail()
          }
          // this.back()
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    filterProduct (query) {
      this.loadingProduct = true
      ProductAPI.findByName(query, 0, 50).then(res => {
        this.products = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingProduct = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingProduct = false
      })
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findSaleByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })
        this.loadingUser = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    filterCustomer (query) {
      this.loadingUser = true
      CustomerApi.findByName(query, this.company.id, 0, 50).then(res => {
        this.customers = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingUser = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    onSelectStatus (event, status) {
      this.statusDetailList = event.details
      this.order.data_sub_status = null
    },
    onRemoveStatus (event, status) {
      this.statusDetailList = []
      this.order.data_sub_status = null
    },
    onSelectSource (event, status) {
      this.data_channel = event.details
      this.order.data_channel = null
    },
    onRemoveSource (event, status) {
      this.data_channel = []
      this.order.data_channel = null
    },
    autoFillCustomer (event) {
      CustomerApi.findByPhone(event.target.value, 0, 1).then(res => {
        if (res != null && res.data != null && res.data.data.records.length > 0) {
          this.customer.id = res.data.data.records[0].id
          this.customer.name = res.data.data.records[0].name
          this.customer.phone = res.data.data.records[0].phone
          this.customer.address = res.data.data.records[0].address
          this.customer.email = res.data.data.records[0].email
          if (!this.order.customer_name) {
            this.order.customer_name = this.customer.name
            this.order.customer_address = this.customer.address
            this.order.customer_email = this.customer.email
          }
        } else {
          this.customer.id = null
          this.order.customer_name = ''
          this.order.customer_address = ''
          this.order.customer_email = ''
        }
      })
    },
    selectedProduct (product) {
      this.$bvModal.hide('listProductModal')
      const p = {
        id: product.id,
        product_name: product.name,
        price: product.price,
        wholesale_price: product.price,
        discount: 0,
        sale_price: product.price,
        quantity: 1,
        total: product.price
      }
      this.productItems.push(p)
    },
    showOrderHistory () {
      this.$bvModal.show('orderHistoryModal')
    },
    showCallHistory () {
      this.$bvModal.show('callHistoryModal')
    },
    showComment (event) {
      this.selectedCrawlId =
      this.$bvModal.show('commentModal')
    },
    toggle () {
      this.orderId = this.order.id
      this.openComment = !this.openComment
    },
    showHistoryPayment () {
      this.$bvModal.show('historyPaymentModal')
    },
    handleTabClick (tabName) {
      if (tabName === 'oneTime') {
        this.showPaymentBtn = true
      } else {
        this.showPaymentBtn = true
      }
    }
  }
}
</script>

<style scoped>
  .custom-rounded-right {
    border-radius: 0 5px 5px 0;
  }
  .text-area-form-control:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
  }

  /* Make slide in box hidden off screen with fixed positioning 100% to the right */
  .slidein {
    position: absolute;
    z-index: 100;
    top: 0;
    right: -100%;
    background: #fbfcff;
    height: 100%;
    /*box-shadow: 1px 1px 5px rgba(0,0,0,.5);*/
    transition: all .5s ease-in-out;
  }

  /* Set positioning back to 0 when toggled opened */
  .open {
    right: 0;
  }

  /* add a close button in case toggle button is hidden on smaller screens */
  .close-btn {
    border: none;
    font-weight: bold;
    font-size: 1em;
    background: transparent;
    position: absolute;
    color: #40a1d3 !important;
    top: 0;
    right: 0;
    padding: .2em .9em;
  }

  .open-btn {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    margin: 5px 10px;
  }

  .message-header {
    background-color: #d9edf7 !important;
    color: #40a1d3 !important;
    padding: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderAddOrEdit.vue